var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ddb6ac2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex gap-2" };
const _hoisted_2 = {
    key: 0,
    class: "flex items-center gap-3 my-2"
};
const _hoisted_3 = { class: "flex items-center justify-between mt-8" };
import { UIButton, UIForm, UIFormItem, UIInput, UISwitch, UITextLgMedium, UITextSmMedium, } from '@gohighlevel/ghl-ui';
import { debounce } from 'lodash';
import { getDomain, getSubdomain } from 'tldts';
import { computed, onBeforeMount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DomainConnectForm',
    props: {
        configuration: null,
        isRecordAddingProcessing: { type: Boolean }
    },
    emits: ["next-step", "manual-flow"],
    setup(__props, { emit }) {
        const props = __props;
        const { t } = useI18n();
        const rules = computed(() => ({
            domain: {
                required: true,
                asyncValidator(_, value) {
                    return __awaiter(this, void 0, void 0, function* () {
                        if (!value.trim()) {
                            return Promise.reject(new Error(t('domainRequired')));
                        }
                        if (value) {
                            if (props.configuration.allowOnlySubdomain) {
                                const subDomain = getSubdomain(value);
                                if (!subDomain) {
                                    return Promise.reject(new Error(t('invalidSubDomain')));
                                }
                            }
                            else {
                                const domain = getDomain(value);
                                if (!domain) {
                                    return Promise.reject(new Error(t('invalidDomain')));
                                }
                            }
                        }
                        return Promise.resolve(value);
                    });
                },
                trigger: ['input', 'blur'],
            },
            enableRootOrWWW: {
                required: false,
            },
        }));
        const formRef = ref();
        const processing = ref(false);
        const formValue = ref({
            domain: '',
            enableRootOrWWW: false,
        });
        const onChangeDomainInput = debounce(() => {
            if (props.configuration.addRootOrWWW) {
                formValue.value.enableRootOrWWW =
                    domainDetails.value.showRoot || domainDetails.value.showWWW;
            }
        }, 500);
        const onAddRecordManually = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                yield ((_b = (_a = formRef.value) === null || _a === void 0 ? void 0 : _a.getForm()) === null || _b === void 0 ? void 0 : _b.validate());
                emit('manual-flow', {
                    domain: domainDetails.value.domain,
                    subDomainValue: domainDetails.value.subDomainValue,
                    addRootOrWWW: formValue.value.enableRootOrWWW,
                });
            }
            catch (err) {
                console.error(err);
            }
        });
        const submitCallback = () => __awaiter(this, void 0, void 0, function* () {
            var _c, _d;
            try {
                processing.value = true;
                yield ((_d = (_c = formRef.value) === null || _c === void 0 ? void 0 : _c.getForm()) === null || _d === void 0 ? void 0 : _d.validate());
                emit('next-step', {
                    domain: domainDetails.value.domain,
                    subDomainValue: domainDetails.value.subDomainValue,
                    addRootOrWWW: formValue.value.enableRootOrWWW,
                });
            }
            catch (err) {
                console.error(err);
            }
            finally {
                processing.value = false;
            }
        });
        const domainDetails = computed(() => {
            var _a, _b;
            const domain = (_a = getDomain(formValue.value.domain)) !== null && _a !== void 0 ? _a : '';
            const subDomainValue = (_b = getSubdomain(formValue.value.domain)) !== null && _b !== void 0 ? _b : '';
            const data = {
                showRoot: false,
                showWWW: false,
                label: domain,
                domain,
                subDomainValue,
            };
            if (domain && props.configuration.addRootOrWWW) {
                if (subDomainValue === 'www') {
                    data.label = domain;
                    data.showRoot = true;
                }
                else if (!subDomainValue) {
                    data.label = `www.${domain}`;
                    data.showWWW = true;
                }
            }
            return data;
        });
        onBeforeMount(() => {
            var _a;
            formValue.value.domain = (_a = props.configuration.prefillDomain) !== null && _a !== void 0 ? _a : '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(UITextLgMedium), { class: "py-3" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('formHeading')), 1)
                    ]),
                    _: 1
                }),
                _createVNode(_unref(UIForm), {
                    model: formValue.value,
                    rules: _unref(rules),
                    ref_key: "formRef",
                    ref: formRef,
                    id: "funnel-website-domain-connect-form"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(_unref(UIFormItem), {
                                class: "flex-1",
                                label: _ctx.$t('domainUrl'),
                                path: "domain"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIInput), {
                                        modelValue: formValue.value.domain,
                                        "onUpdate:modelValue": [
                                            _cache[0] || (_cache[0] = ($event) => ((formValue.value.domain) = $event)),
                                            _unref(onChangeDomainInput)
                                        ],
                                        disabled: __props.configuration.prefillDomain !== undefined,
                                        placeholder: _ctx.$t('domainInputPlaceholder'),
                                        id: "domain"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                            }, 8, ["label"])
                        ]),
                        (_unref(domainDetails).showRoot || _unref(domainDetails).showWWW)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_unref(UISwitch), {
                                    id: "addRootOrWWW",
                                    value: formValue.value.enableRootOrWWW,
                                    "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((formValue.value.enableRootOrWWW) = $event))
                                }, null, 8, ["value"]),
                                _createVNode(_unref(UITextSmMedium), null, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('addRootOrWWWLabel')) + " ", 1),
                                        _createElementVNode("b", null, _toDisplayString(_unref(domainDetails).label), 1)
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["model", "rules"]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(UIButton), {
                        loading: __props.isRecordAddingProcessing,
                        type: "default",
                        text: true,
                        id: "submit-manually",
                        class: "flex",
                        onClick: onAddRecordManually
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UITextSmMedium), { class: "text-black underline opacity-60" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(__props.isRecordAddingProcessing ? '' : _ctx.$t('addRecordManually')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["loading"]),
                    _createVNode(_unref(UIButton), {
                        onClick: submitCallback,
                        type: "primary",
                        id: "submit-funnel-website"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('continue')), 1)
                        ]),
                        _: 1
                    })
                ])
            ], 64));
        };
    }
});
